import React, { useEffect, useMemo, useState } from "react";
import Header from "../../Include/Header";
import Sidebar from "../../Include/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../Include/Footer";
import { Link } from "react-router-dom";
import { Pagination, Search } from "../../Table";
import DropDown from "../../../../Components/DropDown";
import Loader from "../../Include/Loader";
import { getPmsStockList } from "../../../../Store/Erp/stock/getStock";
import moment from "moment";

const StockReportList = () => {
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setlimit] = useState(10);

  const project_id = localStorage.getItem("U_PROJECT_ID");

  useEffect(() => {
    const payload = {
      project_id,
    };

    if (disable === true) {
      dispatch(
        getPmsStockList({
          payload,
          page: currentPage,
          limit,
        })
      );
      setDisable(false);
    }
  }, [disable, dispatch]);

  const entity = useSelector((state) => state.getPmsStockData?.user?.data);
  const totalItems = entity?.total || 0;
  const currentPageFromAPI = entity?.page || 1;
  const limitFromAPI = entity?.limit || 10;

  const stockList = entity?.list || [];

  const commentsData = useMemo(() => {
    let computedComments = stockList;

    if (search) {
      computedComments = computedComments.filter(
        (st) =>
          st?.issueReceiveData?.voucher_no
            .toLowerCase()
            .includes(search?.toLowerCase()) ||
          st?.issueItemDetailsData?.name
            .toLowerCase()
            ?.includes(search?.toLowerCase())
      );
    }
    return computedComments;
  }, [currentPage, search, limit, stockList]);

  const handleRefresh = () => {
    setDisable(true);
    setSearch("");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setDisable(true);
  };

  const handleLimitChange = (val) => {
    setlimit(val);
    setCurrentPage(1);
    setDisable(true);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/user/project-store/dashboard">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">Stock List</li>
                </ul>
              </div>
            </div>
          </div>

          {disable === false ? (
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Stock List</h3>
                            <div className="doctor-search-blk">
                              <div className="top-nav-search table-search-blk">
                                <form>
                                  <Search
                                    onSearch={(value) => {
                                      setSearch(value);
                                      setCurrentPage(1);
                                    }}
                                  />
                                  {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                  <a className="btn">
                                    <img
                                      src="/assets/img/icons/search-normal.svg"
                                      alt="search"
                                    />
                                  </a>
                                </form>
                              </div>
                              <div className="add-group">
                                <button
                                  type="button"
                                  onClick={handleRefresh}
                                  className="btn btn-primary doctor-refresh ms-2"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Refresh"
                                >
                                  <img
                                    src="/assets/img/icons/re-fresh.svg"
                                    alt="refresh"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                          <DropDown
                            limit={limit}
                            onLimitChange={handleLimitChange}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0 datatable">
                        <thead>
                          <tr>
                            <th>SR.</th>
                            <th>Voucher No.</th>
                            <th>Issue Date.</th>
                            <th>Item Name</th>
                            <th>nos</th>
                            <th>Heat No</th>
                            <th>length(mm)</th>
                            <th>width(mm)</th>
                            <th>Topbottom Thickness(mm)</th>
                            <th>Width Thickness(mm)</th>
                            <th>Normal Thickness(mm)</th>
                            <th>lot No</th>
                            <th>UOM</th>
                            <th>QC Nos</th>
                            <th>QC Length(mm)</th>
                            <th>QC Width(mm)</th>
                            <th>QC Top/Bottom Thickness(mm)</th>
                            <th>QC Width Thickness(mm)</th>
                            <th>QC Normal Thickness(mm)</th>
                            <th>QC Lot No</th>
                            <th>Tc No</th>
                            <th>Reject Qty</th>
                            <th>Reject Length(mm)</th>
                            <th>Reject Width(mm)</th>
                            <th>Actual Qty</th>
                            <th>Use Qty</th>
                            <th>Balance Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.map((elem, i) => (
                            <tr key={elem?._id}>
                              <td>{i + 1}</td>
                              <td>
                                {elem?.issueReceiveData?.voucher_no || "-"}
                              </td>
                              <td>
                                {moment(elem?.issueReceiveData?.date).format(
                                  "YYYY-MM-DD"
                                ) || "-"}
                              </td>
                              <td>{elem?.issueItemDetailsData?.name || "-"}</td>

                              <td>{elem?.issueReceiveItemData?.nos || "-"}</td>
                              <td>
                                {elem?.issueReceiveItemData?.heat_no || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.length || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.width || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData
                                  ?.topbottom_thickness || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.width_thickness ||
                                  "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.normal_thickness ||
                                  "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.lot_no || "-"}
                              </td>
                              <td>{elem?.uomData?.name || "-"}</td>
                              <td>
                                {elem?.issueReceiveItemData?.qc_nos || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.qc_length || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.qc_width || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData
                                  ?.qc_topbottom_thickness || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData
                                  ?.qc_width_thickness || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData
                                  ?.qc_normal_thickness || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.qc_lot_no || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.tc_no || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.rej_quantity ||
                                  "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.rej_length || "-"}
                              </td>
                              <td>
                                {elem?.issueReceiveItemData?.rej_width || "-"}
                              </td>
                              <td>{elem?.total_qty || 0}</td>
                              <td>{elem?.use_quantity || 0}</td>
                              <td>{elem?.pending_qty || 0}</td>
                            </tr>
                          ))}

                          {commentsData?.length === 0 ? (
                            <tr>
                              <td colSpan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                    <div className="row align-center mt-3 mb-2">
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                        <div
                          className="dataTables_info"
                          id="DataTables_Table_0_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing {commentsData.length} of {totalItems} data
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="DataTables_Table_0_paginate"
                        >
                          <Pagination
                            total={totalItems}
                            itemsPerPage={limitFromAPI}
                            currentPage={currentPageFromAPI}
                            onPageChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default StockReportList;
